import type { SaveBarMessageProps } from "./save-bar-message.type";

import { getSaveBarMessage } from "./save-bar-message.helper";

export const SaveBarMessage = ({ hasChanges, date }: SaveBarMessageProps) => {
  if (hasChanges) return null;
  const message = getSaveBarMessage(date);
  if (!message) return null;
  return <span className="save-bar-message">{message}</span>;
};
